export enum MyJobStatuses {
    Applied,
    Saved,
    Viewed,
    Invite,
    InProgress,
    Finished
}
